import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import StockStatus from '../StockStatus';
import Price from '../Price';
import BuyButtonContainer from '../../Containers/BuyButton.container';
import WishListButton from '../WishList/WishListButton';
import ResponsiveImage from '../ResponsiveImage';
import useEcommerceDisabled from '../../Hooks/useEcommerceDisabled';
import { useIsBendixTheme } from '../../Hooks/ChannelHooks';

const ProductCard = (props) => {
  const {
    images,
    id: articleNumber,
    articleNumberLabel,
    name,
    boxQuantity,
    packageSize,
    price,
    url,
    parentCategory,
    isInStock,
    stockStatusDescription,
    isAuthenticated,
    quantity,
    currency,
    stockMessage,
    showInfoBox,
    showInfoBoxMessage,
    allowBrokenBox,
    extendedStockStatus,
  } = props;
  const [buyQuantity, setBuyQuantity] = useState(0);
  const ecommerceDisabled = useEcommerceDisabled();
  const isBendix = useIsBendixTheme();

  return (
    <div className="product-card">
      {isAuthenticated && (
        <WishListButton
          noBorder={true}
          articleId={articleNumber}
          quantity={quantity}
        />
      )}
      {images && !!images.length && (
        <a href={url}>
          <ResponsiveImage {...images[0]} className="product-card__image" />
        </a>
      )}
      <a className="product-card__title-and-category" href={url}>
        {name && <span className="product-card__title">{name}</span>}
        {parentCategory && (
          <span className="product-card__category">{parentCategory}</span>
        )}
      </a>
      <div className="product-card__middle">
        <div className="product-card__artno-and-units">
          {articleNumberLabel && (
            <div className="product-card__artno">
              {translate('product.artno')}: <span>{articleNumberLabel}</span>
            </div>
          )}
          {boxQuantity && (
            <div className="product-card__units">
              {translate('product.units')}: <span>{boxQuantity}</span>
            </div>
          )}
        </div>
        {!isBendix && isAuthenticated && !ecommerceDisabled && (
          <StockStatus
            inStock={isInStock}
            description={stockStatusDescription}
            showInfoBox={showInfoBox}
            showInfoBoxMessage={showInfoBoxMessage}
            stockMessage={stockMessage}
            extendedStockStatus={extendedStockStatus}
            packageSize={packageSize}
          />
        )}
      </div>
      {isBendix && isAuthenticated && !ecommerceDisabled && (
        <StockStatus
          inStock={isInStock}
          description={stockStatusDescription}
          showInfoBox={showInfoBox}
          showInfoBoxMessage={showInfoBoxMessage}
          stockMessage={stockMessage}
          extendedStockStatus={extendedStockStatus}
          packageSize={packageSize}
        />
      )}
      <div className="product-card__bottom">
        {isAuthenticated && !ecommerceDisabled && price && (
          <Price
            price={price}
            packageSize={packageSize}
            currency={currency}
            disableTierPriceTooltip={true}
            showForQuantity={buyQuantity}
          />
        )}
        {/* HT Bendix shows the view-product link only when NOT authenticated; everyone else gets the buy button.
            (List view does this via its separate not-auth branch; the grid has no branch, so it's folded in here.) */}
        {!ecommerceDisabled && !(isBendix && !isAuthenticated) ? (
          <BuyButtonContainer
            articleNumber={articleNumber}
            buyButtonLabel={translate('product.add-to-cart')}
            packageSize={packageSize}
            allowBrokenBox={allowBrokenBox}
            extendedStockStatus={extendedStockStatus}
            stockQuantity={quantity}
            disableTierPriceTooltip={true}
            onChangeQuantity={(newQuantity) => setBuyQuantity(newQuantity)}
          />
        ) : (
          <a href={url} className="product-card__anchor-button">
            {translate('product.view-product')}
          </a>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
